import React from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import RealtimePulse from '../components/RealtimePulse'
import Interruption from '../components/Interruption'
import {
  LineContainer,
  DepartureContainer,
  DeletedLabel,
  TimeSpan,
  StopContainer,
  StopParagraph,
  EndStopParagraph,
  Vignette,
  Passage,
  DangerIconWrapper,
} from './Passages.styles'
import {
  primaryTextColor,
  secondaryTextColor,
  getDepartureTimeColor,
  changeColorMode,
} from '../helpers/helpers'
import { getDepartureTime } from './PassagesUtils'
import styled from 'styled-components'
import DangerIcon from '../components/icons/DangerIcon'
import { errorMessages } from '../constants'

const StyledDepartureContainer = styled(DepartureContainer)`
  flex-direction: row;
  svg {
    align-self: flex-start;
  }
`
const Passages = ({ lines = [], error, currentTime }) => {
  const queryParam = queryString.parse(window.location.search)
  const lightMode = changeColorMode(queryParam.inverse)
  const passages = lines.map((line) => {
    const realtime = line.predictionStatussen?.includes('REALTIME') && !error
    const isDeleted = line.predictionStatussen?.includes('DELETED')
    const departureTime = getDepartureTime(
      line.vertrekTheoretischeTijdstip,
      line.vertrekRealtimeTijdstip,
      currentTime,
    )
    const formattedDepartureTime = `${departureTime}${realtime ? "'" : ''}`
    return (
      <Passage
        key={`${line.vertrekTheoretischeTijdstip}-${line.lijnNummerPubliek}-${line.richtingCode}`}
        light={lightMode}
      >
        <LineContainer>
          <Vignette
            backgroundColor={line.kleurAchterGrond}
            backgroundBorder={line.kleurAchterGrondRand}
            color={line.kleurVoorGrond}
          >
            {isDeleted && (
              <DangerIconWrapper light={lightMode}>
                <DangerIcon />
              </DangerIconWrapper>
            )}

            <span>{line.lijnNummerPubliek}</span>
          </Vignette>
          <StopContainer>
            <StopParagraph color={primaryTextColor(queryParam)}>
              {line.lijnRichting}
            </StopParagraph>
            <EndStopParagraph color={secondaryTextColor(queryParam)}>
              {line.bestemming}
            </EndStopParagraph>
            {isDeleted && (
              <div>
                <DeletedLabel isDeleted={isDeleted}>rijdt niet</DeletedLabel>{' '}
              </div>
            )}
          </StopContainer>
        </LineContainer>

        <StyledDepartureContainer realtime={realtime}>
          <TimeSpan
            isDeleted={isDeleted}
            color={getDepartureTimeColor(queryParam, isDeleted)}
          >
            {departureTime === 0 ? 'Nu' : formattedDepartureTime}
          </TimeSpan>
          {realtime && <RealtimePulse variant={lightMode ? '' : 'dark'} />}
        </StyledDepartureContainer>
      </Passage>
    )
  })

  return (
    <>
      {error && (
        <Interruption
          text={errorMessages.GET_PASSAGES_FAILURE}
          variant="error"
          color={primaryTextColor(queryParam)}
        ></Interruption>
      )}
      {passages}
    </>
  )
}

Passages.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.bool,
  currentTime: PropTypes.number,
}

export default Passages
